import { render, staticRenderFns } from "./SetlistsPanel.vue?vue&type=template&id=7d55effc"
import script from "./SetlistsPanel.vue?vue&type=script&lang=js"
export * from "./SetlistsPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports